import React from 'react'
import HeaderComponent from './components/HeaderComponent'
import TableComponent from './components/TableComponent'

const Historypage = () => {
  return (
    <>
      <HeaderComponent/>
      <TableComponent/>
    </>
  )
}

export default Historypage